import BasePreview from "@/components/builder/blocks/base"
import { define, prop } from "@/components/builder/utils"

function FormRow({ children, columns, ...props }) {
  return <BasePreview columns={columns} {...props}>
  <div className="flex flex-row gap-2">
    {children}
  </div>
</BasePreview>
}

export default define('form-row', FormRow)
  .shared(prop.share('FormRow', 'form-row'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.appearance())
  .build()
